import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"


export class PostExcelOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'order/createOrderWithExcel',
      requesterInfo,
    })
  }

  public async addDoc(request: any): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
